import ActionButton from '../common/ActionButton';
import AppContext from '../../AppContext';
import CloseButton from '../common/CloseButton';
import SiteTitleBackButton from '../common/SiteTitleBackButton';
import NewsletterSelectionPage from './NewsletterSelectionPage';
import ProductsSection from '../common/ProductsSection';
import InputForm from '../common/InputForm';
import {ValidateInputForm} from '../../utils/form';
import {getSiteProducts, getSitePrices, hasOnlyFreePlan, isInviteOnlySite, freeHasBenefitsOrDescription, hasOnlyFreeProduct, getFreeProductBenefits, getFreeTierDescription, hasFreeProductPrice, hasMultipleNewsletters, hasFreeTrialTier} from '../../utils/helpers';
import {ReactComponent as InvitationIcon} from '../../images/icons/invitation.svg';

const React = require('react');

export const SignupPageStyles = `
.gh-portal-back-sitetitle {
    position: absolute;
    top: 35px;
    left: 32px;
}

.gh-portal-back-sitetitle .gh-portal-btn {
    padding: 0;
    border: 0;
    font-size: 1.5rem;
    height: auto;
    line-height: 1em;
    color: var(--grey1);
    background:transparent;
}

.gh-portal-popup-wrapper:not(.full-size) .gh-portal-back-sitetitle,
.gh-portal-popup-wrapper.preview .gh-portal-back-sitetitle {
    display: none;
}

.gh-portal-signup-logo {
    position: relative;
    display: block;
    background-position: 50%;
    background-size: cover;
    border-radius: 2px;
    width: 140px;
    height: auto;
    margin: 12px 0 10px;
}

.gh-portal-signup-header,
.gh-portal-signin-header {
    display: flex;
    align-items: center;
    justify-content:center;
}
.gh-portal-signup-header {
    width:100%;
    position:relative;
    border-bottom:1px solid rgba(255,255,255,0.3);
}

.gh-portal-popup-wrapper.full-size .gh-portal-signup-header {
    background: #000;  
}
@media (min-width:768px) {
    .intro {
        width:50%;
        padding:4.2vw;
    }
    .intro-img{
        width:50%;
        padding:4.2vw;
    }
}
.intro {
    width:100%;
    padding:4.2vw;
}
.intro-img{
    width:100%;
    padding:4.2vw;
}
.intro-img img{
    max-width:100%;
    width:100%;
    height:auto;
}
.intro-img h3 {
    font-size: 21px;
    text-align: center;
    color: #fff;
}
.gh-portal-signup-header .gh-portal-main-title,
.gh-portal-signin-header .gh-portal-main-title {
    margin-top: 12px;
}

.gh-portal-signup-logo + .gh-portal-main-title {
    margin: 4px 0 0;
    display:none;
}

.gh-portal-signup-header h2{
    font-weight: bold;
    font-size: 28px;
    margin: 0 0 14px;
    color: #fff;
    text-align: left;
}

.gh-portal-signup-header p{
    color:#dadada;
    hyphens: auto;
    word-wrap: break-word;
    text-align:left;
}

.gh-portal-signup-header .gh-portal-main-subtitle {
    font-size: 1.5rem;
    text-align: center;
    line-height: 1.45em;
    margin: 4px 0 0;
    color: var(--grey3);
}

.gh-portal-logged-out-form-container {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
}

.gh-portal-signup-message {
    display: flex;
    justify-content: center;
    color: #dadada;
    font-size: 1.5rem;
    margin: 16px 0 0;
}

.gh-portal-signup-message,
.gh-portal-signup-message * {
    z-index: 9999;
}

.full-size .gh-portal-signup-message {
    margin: 24px 0 40px;
}

@media (max-width: 480px) {
    .preview .gh-portal-products + .gh-portal-signup-message {
        margin-bottom: 40px;
    }
}

.gh-portal-signup-message button {
    font-size: 1.4rem;
    font-weight: 600;
    margin-left: 4px !important;
}

.gh-portal-signup-message button span {
    display: inline-block;
    padding-bottom: 2px;
    margin-bottom: -2px;
}

.gh-portal-content.signup.invite-only {
    background: none;
}

footer.gh-portal-signup-footer,
footer.gh-portal-signin-footer {
    display: block;
}

.gh-portal-content.signup,
.gh-portal-content.signin {
    max-height: unset !important;
    padding-bottom: 0;
}

.gh-portal-content.signin {
    padding-bottom: 4px;
}

.gh-portal-content.signup .gh-portal-section {
    display: flex;
    padding: 0;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
}

.gh-portal-signup{
    padding: 42px 14px;
    width:75%;
    background: #000;
}
.gh-portal-content.signup.single-field {
    margin-bottom: 4px;
}
.gh-portal-input-section{
    width:100%;
}
.gh-portal-content.signup.single-field .gh-portal-input,
.gh-portal-content.signin .gh-portal-input {
    margin-bottom: 8px;
}

.gh-portal-content.signup.single-field + .gh-portal-signup-footer,
footer.gh-portal-signin-footer {
    padding-top: 12px;
}

.gh-portal-content.signin .gh-portal-section {
    margin-bottom: 0;
}

footer.gh-portal-signup-footer.invite-only {
    height: unset;
}

footer.gh-portal-signup-footer.invite-only .gh-portal-signup-message {
    margin-top: 0;
}

.gh-portal-invite-only-notification {
    margin: 8px 32px 24px;
    padding: 0;
    text-align: center;
    color: var(--grey2);
}

.gh-portal-icon-invitation {
    width: 44px;
    height: 44px;
    margin: 12px 0 2px;
}

.gh-portal-popup-wrapper.full-size .gh-portal-popup-container.preview footer.gh-portal-signup-footer {
    padding-bottom: 32px;
}

.gh-portal-invite-only-notification + .gh-portal-signup-message {
    margin-bottom: 12px;
}

.gh-portal-free-trial-notification {
    max-width: 480px;
    text-align: center;
    margin: 24px auto;
    color: #dadada;
}

.wrapper-products h3{
    font-weight: 500;
    font-size: 18px;
    color: #403a36;
    margin-bottom: 14px;
    text-align:center;
}
.wrapper-products{
    width:100%;
}
.gh-portal-section.step-1,
.gh-portal-section.step-2 {
    transition: all 0.5s ease;
    opacity: 0;
    transform: translateX(100%);
}

.gh-portal-section.step-1.active,
.gh-portal-section.step-2.active {
    opacity: 1;
    transform: translateX(0);
}

.gh-portal-section.step-1.inactive,
.gh-portal-section.step-2.inactive {
    opacity: 0;
    transform: translateX(-100%);
}

.gh-portal-navigation {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}
.gh-portal-powered {
    display:none!important;
}
section.gh-portal-logged-out-form-container{
    width:25%;
    background:#000;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    padding:4vw;
    flex-direction:column;
}
.signin .gh-portal-logged-out-form-container{
    display:block;
}
section.gh-portal-logged-out-form-container p{
    color:#dadada;
}
.gh-portal-headers{
    background: #000;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    display: flex;
    justify-content: center;
    padding: 13px;
    align-items: center;
    position: sticky;
    width: 100%;
    z-index: 100000;
    top: 0;
    left: 0;
}
.gh-portal-headers .gh-portal-back-sitetitle .gh-portal-btn{
    color:#fff;
}
.wrapper-content{
    display:flex;
}
.gh-portal-btn.gh-portal-btn-link{
    color:#fff!important;
}
.razones-link{
    color:#fff;
    font-weight:bold;
}
#razones {
    border-top:1px solid;
}
.gh-razon {
    display:flex;
    background: #000;
    border-bottom: 1px solid rgba(255,255,255,0.3);
}
.gh-razon:nth-child(odd) {
    flex-direction:row-reverse;
}
.gh-razon-img, .gh-razon-content {
    width: 50%;
    padding:7vw;
    display:flex;
    flex-direction:column;
    justify-content:center;
}
.gh-razon-img{
    align-items:center;
}
.gh-razon-img img{
    width:100%;
    max-width:350px;
    height:auto;
}
.gh-razon-content h3{
    color:#fff;
    margin-bottom: 21px;
}
.gh-razon-content p{
    color:#dadada;
    margin-bottom:30px;
}
.gh-portal-btn-main{
    background:#fff!important;
    color:#000!important;
}
@media (max-width: 960px) {
    .gh-razon-img, .gh-razon-content, .gh-portal-logged-out-form-container, .gh-portal-signup, .intro, .intro-img{
        width:100%!important;
    }
    .gh-razon, .gh-portal-signup-header, .wrapper-content{
        display:flex;
        flex-wrap:wrap;
    }
    .gh-razon:nth-child(odd) {
        flex-direction:row;
    }
    .gh-razon-img img {
        width: 100%;
        max-width: 210px;
        height: auto;
    }
}

@media (max-width: 480px) {
    .gh-portal-signup-logo {
        width: auto;
        height: 48px;
    }
    .gh-portal-popup-container.full-size{
        padding:0!important;
    }
}

@media (min-width: 480px) and (max-width: 820px) {
    .gh-portal-powered.outside {
        left: 50%;
        transform: translateX(-50%);
    }
}
`;

class SignupPage extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            plan: 'free',
            showNewsletterSelection: false
        };
    }
    /* eslint-disable no-console */
    componentDidMount() {
        const {member} = this.context;
        if (member) {
            this.context.onAction('switchPage', {
                page: 'accountHome'
            });
        }

        // Handle the default plan if not set
        this.handleSelectedPlan();
        setTimeout(() => {
            const razonesLink = document.querySelector('.razones-link');
            if (razonesLink) {
                razonesLink.addEventListener('click', this.scrollToRazones);
            }
        }, 0);
    }
    /* eslint-enable no-console */
    componentDidUpdate() {
        this.handleSelectedPlan();
    }

    handleSelectedPlan() {
        const {site, pageQuery} = this.context;
        const prices = getSitePrices({site, pageQuery});

        const selectedPriceId = this.getSelectedPriceId(prices, this.state.plan);
        if (selectedPriceId !== this.state.plan) {
            this.setState({
                plan: selectedPriceId
            });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        const razonesLink = document.querySelector('.razones-link');
        if (razonesLink) {
            razonesLink.removeEventListener('click', this.scrollToRazones);
        }
    }

    handleSignup(e) {
        const {site, onAction} = this.context;
        e.preventDefault();
        this.setState((state) => {
            return {
                errors: ValidateInputForm({fields: this.getInputFields({state})})
            };
        }, () => {
            const {name, email, plan, errors} = this.state;
            const hasFormErrors = (errors && Object.values(errors).filter(d => !!d).length > 0);
            if (!hasFormErrors) {
                if (hasMultipleNewsletters({site})) {
                    this.setState({
                        showNewsletterSelection: true,
                        pageData: {name, email, plan},
                        errors: {}
                    });
                } else {
                    this.setState({
                        errors: {}
                    });
                    onAction('signup', {name, email, plan});
                }
            }
        });
    }

    handleChooseSignup(e, plan) {
        e.preventDefault();
        this.setState((state) => {
            return {
                errors: ValidateInputForm({fields: this.getInputFields({state})})
            };
        }, () => {
            const {onAction, site} = this.context;
            const {name, email, errors} = this.state;
            const hasFormErrors = (errors && Object.values(errors).filter(d => !!d).length > 0);
            if (!hasFormErrors) {
                if (hasMultipleNewsletters({site})) {
                    this.setState({
                        showNewsletterSelection: true,
                        pageData: {name, email, plan},
                        errors: {}
                    });
                } else {
                    onAction('signup', {name, email, plan});
                    this.setState({
                        errors: {}
                    });
                }
            }
        });
    }

    handleInputChange(e, field) {
        const fieldName = field.name;
        const value = e.target.value;
        this.setState({
            [fieldName]: value
        });
    }

    handleSelectPlan = (e, priceId) => {
        e && e.preventDefault();
        // Hack: React checkbox gets out of sync with dom state with instant update
        this.timeoutId = setTimeout(() => {
            this.setState((prevState) => {
                return {
                    plan: priceId
                };
            });
        }, 5);
    };
    
    onKeyDown(e) {
        // Handles submit on Enter press
        if (e.keyCode === 13){
            this.handleSignup(e);
        }
    }

    getSelectedPriceId(prices = [], selectedPriceId) {
        if (!prices || prices.length === 0) {
            return 'free';
        }
        const hasSelectedPlan = prices.some((p) => {
            return p.id === selectedPriceId;
        });

        if (!hasSelectedPlan) {
            return prices[0].id || 'free';
        }

        return selectedPriceId;
    }

    getInputFields({state, fieldNames}) {
        const {portal_name: portalName} = this.context.site;

        const errors = state.errors || {};
        const fields = [
            {
                type: 'email',
                value: state.email,
                placeholder: 'Correo electrónico',
                label: 'Correo electrónico',
                name: 'email',
                required: true,
                tabindex: 2,
                errorMessage: errors.email || ''
            }
        ];

        /** Show Name field if portal option is set*/
        if (portalName) {
            fields.unshift({
                type: 'text',
                value: state.name,
                placeholder: 'Nombre completo',
                label: 'Nombre completo',
                name: 'name',
                required: true,
                tabindex: 1,
                errorMessage: errors.name || ''
            });
        }
        fields[0].autoFocus = true;
        if (fieldNames && fieldNames.length > 0) {
            return fields.filter((f) => {
                return fieldNames.includes(f.name);
            });
        }
        return fields;
    }
    scrollToRazones(e) {
        e.preventDefault();

        const razonesSection = document.querySelector('#razones');

        if (razonesSection) {
            razonesSection.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }
    renderSubmitButton() {
        const {action, site, brandColor, pageQuery} = this.context;

        if (isInviteOnlySite({site, pageQuery})) {
            return null;
        }

        let label = 'Continue';
        const showOnlyFree = pageQuery === 'free' && hasFreeProductPrice({site});

        if (hasOnlyFreePlan({site}) || showOnlyFree) {
            label = 'Sign up';
        } else {
            return null;
        }

        let isRunning = false;
        if (action === 'signup:running') {
            label = 'Sending...';
            isRunning = true;
        }
        let retry = false;
        if (action === 'signup:failed') {
            label = 'Retry';
            retry = true;
        }

        const disabled = (action === 'signup:running') ? true : false;
        return (
            <ActionButton
                style={{width: '100%'}}
                retry={retry}
                onClick={e => this.handleSignup(e)}
                disabled={disabled}
                brandColor={brandColor}
                label={label}
                isRunning={isRunning}
                tabIndex='3'
            />
        );
    }

    renderProducts() {
        const {site, pageQuery} = this.context;
        const products = getSiteProducts({site, pageQuery});
        return (
            <>
                <ProductsSection
                    handleChooseSignup={(...args) => this.handleChooseSignup(...args)}
                    products={products}
                    onPlanSelect={this.handleSelectPlan}
                />
            </>
        );
    }

    renderFreeTrialMessage() {
        const {site} = this.context;
        if (hasFreeTrialTier({site})) {
            return (
                <p className='gh-portal-free-trial-notification'>Después de que finalice el período de prueba gratuito, se te cobrará el precio regular del nivel que hayas elegido. Siempre puedes cancelar antes de eso.</p>
            );
        }
        return null;
    }

    renderLoginMessage() {
        const {brandColor, onAction} = this.context;
        return (
            <div>
                {this.renderFreeTrialMessage()}
                <div className='gh-portal-signup-message'>
                    <div>¿Ya eres miembrx?</div>
                    <button
                        className='gh-portal-btn gh-portal-btn-link'
                        style={{color: brandColor}}
                        onClick={() => onAction('switchPage', {page: 'signin'})}
                    >
                        <span>Inicia sesión</span>
                    </button>
                </div>
            </div>
        );
    }

    renderForm() {
        const {site, pageQuery} = this.context;

        if (this.state.showNewsletterSelection) {
            return (
                <NewsletterSelectionPage
                    pageData={this.state.pageData}
                    onBack={() => {
                        this.setState({
                            showNewsletterSelection: false
                        });
                    }}
                />
            );
        }

        if (isInviteOnlySite({site, pageQuery})) {
            return (
                <section>
                    <div className='gh-portal-section'>
                        <p className='gh-portal-invite-only-notification'>This site is invite-only, contact the owner for access.</p>
                        {this.renderLoginMessage()}
                    </div>
                </section>
            );
        }

        const freeBenefits = getFreeProductBenefits({site});
        const freeDescription = getFreeTierDescription({site});
        const showOnlyFree = pageQuery === 'free' && hasFreeProductPrice({site});
        const hasOnlyFree = hasOnlyFreeProduct({site}) || showOnlyFree;
        const sticky = !showOnlyFree && (freeBenefits.length || freeDescription); 

        return (
            <section className="gh-portal-signup">
                <div className='gh-portal-section'>
                    <div className='wrapper-products'>
                        {this.renderProducts()}

                        {(hasOnlyFree ?
                            <div className={'gh-portal-btn-container' + (sticky ? ' sticky m24' : '')}>
                                <div className='gh-portal-logged-out-form-container'>
                                    {this.renderSubmitButton()}
                                    {this.renderLoginMessage()}
                                </div>
                            </div>
                            :
                            this.renderLoginMessage())}
                    </div>
                </div>
            </section>
        );
    }

    renderSiteLogo() {
        const {site, pageQuery} = this.context;

        const siteLogo = site.icon;

        const logoStyle = {};

        if (siteLogo) {
            logoStyle.backgroundImage = `url(${siteLogo})`;
            return (
                <img className='gh-portal-signup-logo' src='https://mcusercontent.com/be9203bfaa2f0c1cf8e7b1b8a/images/ed1f3073-61bf-91a5-1bdb-df95a17c2043.png' alt={site.title} />
            );
        } else if (isInviteOnlySite({site, pageQuery})) {
            return (
                <InvitationIcon className='gh-portal-icon gh-portal-icon-invitation' />
            );
        }
        return null;
    }

    renderFormHeader() {
        const {site} = this.context;
        const siteTitle = site.title || '';
        
        return (
            <header className='gh-portal-signup-header opinion-suscribe-header'>
                <div className="intro">
                    <span className="hidden">{siteTitle}</span>
                    <h2>Enriquece tu comprensión del mundo con el único medio que reúne a más de 100 mujeres escribiendo columnas de opinión.</h2>
                    <p lang="es">Tu suscripción a Opinión 51 no solo te da acceso a contenido de calidad, sino que también fortalece la voz de las mujeres en los medios. Al unirte, apoyas la representación equitativa y contribuyes a un mundo donde la libertad de expresión y la igualdad son pilares fundamentales.</p>
                    <a href="#razones" className="razones-link">¿Por qué suscribirte?</a>
                </div>
                <div className="intro-img">
                    <h3>Más de 100 columnas por menos de lo que cuesta un café.</h3>
                    <img className='phones' src='https://mcusercontent.com/be9203bfaa2f0c1cf8e7b1b8a/images/9578c417-8457-19b4-27f1-e4ea4c001864.png' alt={site.title} />
                </div>
            </header>
        );
    }
    renderFormColumn() {
        const fields = this.getInputFields({state: this.state});
        return (
            <section className='gh-portal-logged-out-form-container'>
                <p>Ingresa tu nombre completo y correo electrónico. Elige tu tipo de suscripción y únete al cambio.</p>
                <InputForm
                    fields={fields}
                    onChange={(e, field) => this.handleInputChange(e, field)}
                    onKeyDown={e => this.onKeyDown(e)}
                />
            </section>
		
        );
    }
    renderRazones() {
        return (
            <div id='razones'>
                <div className='gh-razon'>
                    <div className='gh-razon-img'>
                        <img className='phone' src='https://mcusercontent.com/be9203bfaa2f0c1cf8e7b1b8a/images/105bd8dd-ccc2-36da-6cd2-9ae1b0b8e78e.png' alt='Opinión 51' />
                    </div>
                    <div className='gh-razon-content'>
                        <h3>Apoya el Periodismo Independiente</h3>
                        <p>Tu suscripción sustenta una plataforma donde las mujeres, representando el 51% de la población, lideran la narrativa. Apoyas un espacio que valora la diversidad de pensamiento y la integridad periodística.</p>
                    </div>
                </div>
                <div className='gh-razon'>
                    <div className='gh-razon-img'>
                        <img className='phone' src='https://mcusercontent.com/be9203bfaa2f0c1cf8e7b1b8a/images/4cdf5f10-d421-844f-ee4b-b5c86e43425e.png' alt='Opinión 51' />
                    </div>
                    <div className='gh-razon-content'>
                        <h3>Amplifica Nuestras Voces</h3>
                        <p>Cada artículo, cada columna que lees y compartes, contribuye a extender el alcance de nuestras voces, permitiendo que mensajes cruciales resuenen en toda la sociedad.</p>
                    </div>
                </div>
                <div className='gh-razon'>
                    <div className='gh-razon-img'>
                        <img className='phone' src='https://mcusercontent.com/be9203bfaa2f0c1cf8e7b1b8a/images/307bf7e9-11e0-b3ca-4a99-fd37f3b70d07.png' alt='Opinión 51' />
                    </div>
                    <div className='gh-razon-content'>
                        <h3>Construye Comunidad</h3>
                        <p>Forma parte de una comunidad activa que participa en la configuración de un futuro más inclusivo y justo. Tus comentarios, tus ideas, y tu participación activa enriquecen el diálogo.</p>
                    </div>
                </div>
                <div className='gh-razon'>
                    <div className='gh-razon-img'>
                        <img className='phone' src='https://mcusercontent.com/be9203bfaa2f0c1cf8e7b1b8a/images/c4e5f26a-eb0f-7f5a-59b9-65b3be8b8b31.png' alt='Opinión 51' />
                    </div>
                    <div className='gh-razon-content'>
                        <h3>Beneficios Exclusivos</h3>
                        <p>Además del acceso ilimitado a todo nuestro contenido, recibirás invitaciones a eventos especiales, diálogos directos con nuestras columnistas y contenido especialmente curado para ti.</p>
                    </div>
                </div>
                <div className='gh-razon'>
                    <div className='gh-razon-img'>
                        <img className='phone' src='https://mcusercontent.com/be9203bfaa2f0c1cf8e7b1b8a/images/0e17e7ed-df51-76fb-fc8d-800dbf113e28.png' alt='Opinión 51' />
                    </div>
                    <div className='gh-razon-content'>
                        <h3>Hazte Eco del Cambio</h3>
                        <p>En Opinión 51, creemos en el impacto colectivo. Tu suscripción no solo nos permite continuar nuestra misión, sino que también inspira a otros a unirse a este movimiento hacia una sociedad más equitativa y libre.</p>
                    </div>
                </div>
            </div>
        );
    }

    getClassNames() {
        const {site, pageQuery} = this.context;
        const plansData = getSitePrices({site, pageQuery});
        const fields = this.getInputFields({state: this.state});
        let sectionClass = '';
        let footerClass = '';

        if (plansData.length <= 1 || isInviteOnlySite({site})) {
            if ((plansData.length === 1 && plansData[0].type === 'free') || isInviteOnlySite({site, pageQuery})) {
                sectionClass = freeHasBenefitsOrDescription({site}) ? 'singleplan' : 'noplan';
                if (fields.length === 1) {
                    sectionClass = 'single-field';
                }
                if (isInviteOnlySite({site})) {
                    footerClass = 'invite-only';
                    sectionClass = 'invite-only';
                }
            } else {
                sectionClass = 'singleplan';
            }
        }

        return {sectionClass, footerClass};
    }

    render() {
        let {sectionClass} = this.getClassNames();
        return (
            <>
                <div className='gh-portal-headers'>
                    <div className='gh-portal-back-sitetitle'>
                        <SiteTitleBackButton
                            onBack={() => {
                                if (this.state.showNewsletterSelection) {
                                    this.setState({
                                        showNewsletterSelection: false
                                    });
                                } else {
                                    this.context.onAction('closePopup');
                                }
                            }}
                        />
                    </div>
                    {this.renderSiteLogo()};
                    <CloseButton />
                </div>
                <div className={'gh-portal-content signup ' + sectionClass}>
                    {this.renderFormHeader()}
                    <div className='wrapper-content'>
                        {this.renderFormColumn()}
                        {this.renderForm()}
                    </div>
                </div>
                {this.renderRazones()}
                {/* <footer className={'gh-portal-signup-footer gh-portal-logged-out-form-container ' + footerClass}>
                    {this.renderSubmitButton()}
                    {this.renderLoginMessage()}
                </footer> */}
            </>
        );
    }
}

export default SignupPage;
